import React, { useState } from "react";
import styles from "./AppBar.module.css";

import { MenuLogo, MenuTop } from "../index";

//ui
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Paper from "@material-ui/core/Paper";

import MenuTabs from "../MenuTabs/MenuTabs";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    boxShadow: "none",
    textAlign: "center",
  },
}));

const AppBar = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open);
  };

  return (
    <span className={styles.container}>
      <Paper className={classes.root}>
        <IconButton aria-label="delete" onClick={toggleDrawer(true)}>
          <MenuIcon />
        </IconButton>
      </Paper>

      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        className={styles.drawer}
      >
        <span className={styles.header_drawer}>
          <MenuLogo />
          <Divider />
        </span>

        <span>
          <MenuTabs variant="scrollable" orientation="vertical" />
          <Divider />
        </span>

        <span className={styles.menu_top}>
          <MenuTop />
          <Divider />
        </span>
      </Drawer>
    </span>
  );
};
export default AppBar;
